<template>
    <div class="datumList">
        <div class="paddingH16 clearfix" :class="layout">
            <div class="datumItem" v-for="dataItem in dataList"
                 :key="dataItem.id" @click="viewItem(dataItem)">

                <!-- 纵向图文布局 -->
                <div class="inner" v-if="layout === 'verticalImageTextLayout'">

                    <div class="flexLayout">
                        <div style="width: 76px; margin-right: 6px;">
                            <div class="imageArea roundBorder8 hiddenOverflow"
                                 style="width: 100%; height: 76px;">
                                <img class="fullSpace" :src="dataItem.coverImg"/>
                            </div>
                        </div>
                        <div class="flexItem">
                            <div class="titleArea maxHeightTwoLine hiddenOverflow"
                                 style="padding-top: 9px; line-height: 1.3em; height: 2.6em; text-overflow: ellipsis">
                                {{dataItem.title}}
                                <span v-if="(isDebug || mode === 'professional') && dataItem.isPay" class="green">
                                    [已支付]
                                </span>

                            </div>
                            <div class="clearfix hidden" style="margin-top: 9px;">
                                <!-- 免费 -->
                                <span class="red" v-if="dataItem.chargeMode==0">免费</span>

                                <!-- 收费 -->
                                <template v-else>

                                    <!-- 会员课程 -->
                                    <template v-if="dataItem.isV">
                                        <!-- 会员课程已购买会员 -->
                                        <template v-if="userInstance && userInstance.isContentHasVipPrivilege('datum')">
                                            <span class="grey deleteLine font14r">原价￥{{dataItem.price}}</span>
                                            <span class="marginL8 red">免费</span>
                                        </template>

                                        <!-- 会员课程未购买会员 -->
                                        <template v-else="">
                                            <i class="fl icon-category icon datumVipLabelIcon marginR8"></i>
                                            <span class=" marginL8 red">￥{{dataItem.price}}</span>
                                        </template>
                                    </template>

                                    <!-- 非会员课程 -->
                                    <template v-else="">
                                        <span class=" marginL8" v-if="dataItem.isPay">￥0.0</span><!-- 已购买 -->
                                        <span class=" marginL8 red" v-else>￥{{dataItem.price}}</span><!-- 未购买 -->
                                    </template>
                                </template>

                            </div>
                            <div class="alignR" :data-datumtype="dataItem.datumType">
                                <span class="datumTypeTag wordType" v-if="isHasDatumType(dataItem, 'WORD')">文档</span>
                                <span class="datumTypeTag teachingPlanType" v-if="isHasDatumType(dataItem, 'TEACHING_PLAN')">教案</span>
                                <span class="datumTypeTag coursewareType" v-if="isHasDatumType(dataItem, 'COURSEWARE')">课件</span>
                                <span class="datumTypeTag collectionType" v-if="isHasDatumType(dataItem, 'COLLECTION')">合集</span>
                                <span class="datumTypeTag tableType" v-if="isHasDatumType(dataItem, 'TABLE')">表格</span>
                                <span class="datumTypeTag posterType" v-if="isHasDatumType(dataItem, 'POSTER')">海报</span>
                                <span class="datumTypeTag speakType" v-if="isHasDatumType(dataItem, 'SPEAK')">话术</span>
                                <span class="datumTypeTag environmentCreativeType" v-if="isHasDatumType(dataItem, 'ATLAS')">环创</span>
                            </div>
                        </div>
                    </div>


                </div>

            </div>

            <!-- 暂时搜不到内容，搜搜其他内容吧 -->
            <div class="alignC paddingT20 font14r" v-show="dataList.length < 1">
                <img src="notice/notice_no_search_result.png" width="282"/><br/>
                暂时搜不到内容，可
                <span class="blue" @click="contact()">联系师讯客服</span>
                搜索更多内容
            </div>

            <div class="font12r grey60 alignCenter" style="padding: 26px 0 9px;"
                 v-show="status=='ready' && pagination.current == pagination.totalPage"
                 :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                -没有更多啦-
            </div>

        </div>
    </div>
</template>
<script>

import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// style
import '@comp/datum/datum.scss';

// data
import bizTypeEnum from '@data/bizTypeEnum';
import externalApp from '@data/externalApp';

// util
import appHelper from '@util/appHelper';
import consoleHelper from "@util/consoleHelper";
import arrayHelper from "@util/arrayHelper";

const config = {
    apiConfig : {
        list : {
            url : 'portal/v4/index/search',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            params : {
                bizType : bizTypeEnum.DATUM.code
            }
        }
    }
};

export default {
    name: "datumList",
    extends : shixunPagePart,
    props : {
        layout : {
            type : String,
            default : 'verticalImageTextLayout'
        }
    },
    data () {
        return {
            apiConfig: config.apiConfig,
            enableDataList : true,
            scrollToLoadNextPage : true,
            isDebug : consoleHelper.getDebugStatus(),
            debug   : consoleHelper.getDebugStatus(),
        }
    },
    methods : {
        viewItem(dataItem) {
            appHelper.goToPage('datumDetail', {
                id : dataItem.id
            });
        },
        contact() {
            appHelper.redirect(externalApp.oldShixun.baseUrl + 'html/me/contact.html');
        },
        isHasDatumType(dataItem, type = '') {
            console.log('type= ' + type);
            console.log(dataItem);
            let datumTypeString = dataItem.fileType || '';
            console.log('datumTypeString= ' + datumTypeString);
            let list = datumTypeString.split(',');
            console.log(list);
            let result = arrayHelper.existElement(type, list);
            console.log(result);
            return result
        }
    }
};
</script>

<style lang="scss" scope>
.datum_price{

    font-size: 16px;

    font-weight: 500;
    color: #FC3439;

}
.datumItem {
    margin-bottom: 20px;
}

.datumTypeTag {
    display: inline-block;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 9px;
    color: white;
    background: #000;
    font-size: 12px;
}
.datumTypeTag.wordType {
    background: #FE5747;
}
.datumTypeTag.coursewareType {
    background: #FFCE00;
}
.datumTypeTag.teachingPlanType {
    background: #779F10;
}
.datumTypeTag.collectionType {
    background: #FD9903;
}
.datumTypeTag.environmentCreativeType {
    background: #00A9F7;
}
.datumTypeTag.speakType {
    background: #B3EE18;
}
.datumTypeTag.tableType {
    background: #077938;
}
.datumTypeTag.posterType {
    background: #EF6EF9;
}
</style>
